<template>
  <div class="flex flex-wrap justify-start items-center w-full">
    <base-dblclick-input
      modelType="contact"
      :model-id="clientContact.id"
      field-name="personal_email"
      :field-value="clientContact.personal_email"
      :canCopy="true"
      inputType="email"
      @refetch="fetchNewClients"
    >
      <slot name="icon"></slot>
    </base-dblclick-input>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      clientContact: Object
  })

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }

</script>